import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Thumbnail from '@amzn/meridian/thumbnail';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import { InverseButton } from 'src/common/buttons';
import { useOffRampToAmazon, usePageContext } from 'src/hooks';
const ImageContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding-bottom: 40px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const StyledDiv = styled.div `
  position: absolute;
  bottom: 0;
`;
/**
 * AdBlock component displays an Amazon-branded promotional section on the product details page.
 */
export const AdBlock = ({ offRampUrl }) => {
    const { commonBundle: bundle } = usePageContext();
    const offRampToAmazon = useOffRampToAmazon();
    const onButtonClick = () => {
        offRampToAmazon(offRampUrl, ReportActionSource.AdAccountBox);
    };
    return (_jsxs(Column, { spacingInset: "350 none none none", spacing: "none", "data-testid": "ad-block", children: [_jsxs(ImageContainer, { children: [_jsx(Row, { height: "140px", width: "100%", children: _jsx("img", { loading: "lazy", src: "https://m.media-amazon.com/images/G/01/ShopExternal/images/PRIME_PD24_PD23_BOXES_BLUE._CB554467197_.jpg", alt: bundle.getMessage('headerImage'), "data-testid": "header-image" }) }), _jsx(StyledDiv, { children: _jsx(Thumbnail, { size: "large", source: "https://m.media-amazon.com/images/G/01/ShopExternal/images/amazon_profile_image._CB599320652_.png" }) })] }), _jsxs(Column, { spacingInset: "300 350 none 350", spacing: "none", children: [_jsx(Text, { alignment: "center", type: "h300", children: bundle.getMessage('amazon') }), _jsx(Text, { alignment: "center", type: "b300", children: bundle.getMessage('deliveringSmiles') })] }), _jsx(Row, { alignmentHorizontal: "center", spacingInset: "450 350", children: _jsx(InverseButton, { "data-testid": "ad-block-see-more-on-amazon", onClick: onButtonClick, children: bundle.getMessage('seeMoreOnAmazon') }) })] }));
};
